import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Hours planning every class', 'Repetitive activities', 'No connection to art history', 'Not knowing how to grade properly', 'Unmotivated students'];
const after = ['5-minute review and you’re set', 'Varied creative projects', 'Art movements integrated', 'Rubrics and assessments ready', 'Students expressing themselves freely'];
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-366">
      <Reveal className="mx-auto max-w-5xl" data-id="element-367">
        <div className="mx-auto max-w-3xl text-center" data-id="element-368">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-red" data-id="element-369">
            THE ART READY DIFFERENCE
          </p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight md:text-5xl" data-id="element-370">
            From an Overwhelmed Teacher to an{' '}
            <span className="italic text-brand-red" data-id="element-371">Inspired Guide.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-372">
            Give your lessons a clear rhythm, your students more creative
            confidence, and yourself the time to enjoy teaching again.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-373">
          {[['+300', 'READY-TO-TEACH ACTIVITIES'], ['10', 'COMPLETE DIGITAL VOLUMES'], ['100%', 'INSTANTLY DOWNLOADABLE']].map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-374">
              <strong className="block font-serif text-3xl leading-none text-brand-red" data-id="element-375">
                {value}
              </strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-376">
                {label}
              </span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(26,26,26,0.08)]" data-id="element-377">
          <div className="grid md:grid-cols-2" data-id="element-378">
            <Comparison title="BEFORE" items={before} positive={false} data-id="element-379" />
            <Comparison title="WITH ART READY" items={after} positive data-id="element-380" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-381">
            A complete system to plan less and teach with more purpose.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#f3eadc]'}`} data-id="element-382">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-383">
        <div data-id="element-384">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-red' : 'text-brand-gray'}`} data-id="element-385">
            {positive ? 'THE ART READY SYSTEM' : 'THE COST OF IMPROVISING'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight" data-id="element-386">
            {title}
          </h3>
          <p className="mt-2 max-w-xs text-xs leading-relaxed text-brand-gray" data-id="element-387">
            {positive ? 'Walk into every lesson with a clear, creative plan.' : 'What planning from scratch quietly takes from your week.'}
          </p>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-red text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-388">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-389" />
        </div>
      </div>

      <ul className="space-y-2.5" data-id="element-390">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-391">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-red' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-392" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-393">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}